export const SET_CAROUSEL = 'SET_CAROUSEL'